import styled from 'styled-components'
import { ImageGreenShadowMobile } from '../../assets'

export const ContainerBackground = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: #1D3739;
  background-image: url(${ImageGreenShadowMobile}), url(${p => p.image});
  background-repeat: repeat-x, no-repeat;
  background-size: 100%  100%, cover;
  background-position:  bottom right, center center;

  @media (min-width: 768px) {
    background-image: url(${ImageGreenShadowMobile}), url(${p => p.image});
    background-repeat: repeat-x, no-repeat;
    background-size: 100%  100%, cover;
    height: 100%;
  }
`

export const ContainerSearchBar = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 40px;
`

export const CollectionDetailDiv = styled.div`
  padding: 10px 20px;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;

  @media (min-width: 768px){
    margin-left: 100px;
    padding-bottom: 36px;
    padding: 10px 20px 36px 20px;
    height: 99%;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: 30px;

  @media (min-width: 768px){
    position: absolute;
    top: 100px;
  }
`